import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6" data-testid="not-found-page">
      <Helmet>
        <title>Page not found · EVIQ</title>
        <meta name="robots" content="noindex" />
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <div className="text-center max-w-md">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-zinc-500">404 — Not found</div>
        <h1 className="font-display mt-3 text-3xl sm:text-4xl font-semibold">This page doesn&rsquo;t exist.</h1>
        <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
          The address may have changed, or the link was mistyped. Everything EVIQ does lives one click away.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="brand-gradient text-black font-semibold rounded-md px-5 py-2.5 text-sm inline-flex items-center gap-2 hover:opacity-90 transition-opacity"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={2.4} /> Back to eviq.pro
          </Link>
          <Link to="/vin" className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid="not-found-vin-link">
            Check a battery by VIN
          </Link>
        </div>
      </div>
    </div>
  );
}
